// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { lazy } from "react";
import { store } from "../../../store/store";

import { HydrateFallback } from "../../Loaders/RootLoader/rootLoader";
import { withSuspense } from "../../../hooks/LazyLoader/withSuspense";

import { facilityLoader } from "../../Loaders/FacilityLoader/FacilityLoader";
import { equipmentGroupLoader } from "../../Loaders/EquipmentGroupLoader/EquipmentGroupLoader";
import { equipmentLoader } from "../../Loaders/EquipmentLoader/EquipmentLoader";
import { controlLoader } from "../../Loaders/ControlLoader/ControlLoader";
import { presetSequenceLoader } from "../../Loaders/PresetSequenceLoader/PresetSequenceLoader";

const lazyPage = (path) => lazy(() => import(`../../Pages/${path}`));

const Facility = lazyPage("Facility");
const EquipmentDetail = lazyPage("EquipmentDetail");
const GroupEquipment = lazyPage("GroupEquipment");
const CameraControl = lazyPage("CameraControl");
const CameraControlRedirect = lazyPage("CameraControlRedirect");
const CameraGroupControl = lazyPage("CameraGroupControl");
const ButtonAssignment = lazyPage("ButtonAssignment");
const PresetSequence = lazyPage("PresetSequence");
const Multiview = lazyPage("Multiview");

// Nodes Routes
const nodesRoutes = [
  {
    path: "/",
    loader: facilityLoader,
    element: withSuspense(Facility),
    shouldRevalidate: ({ currentParams, nextParams }) => {
      const companyUuid = store.getState().companies.company?.company_uuid;
      return (
        currentParams.showId !== nextParams.showId ||
        facilityLoader.lastCompanyUuid !== companyUuid
      );
    },
    HydrateFallback,
    children: [
      {
        path: "equipmentGroup/:equipmentGroupId",
        loader: equipmentGroupLoader,
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.equipmentGroupId !== nextParams.equipmentGroupId,
        element: withSuspense(GroupEquipment),
        HydrateFallback,
      },
      {
        loader: equipmentLoader,
        path: "equipment/:equipmentId",
        element: withSuspense(EquipmentDetail),
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.equipmentId !== nextParams.equipmentId,
        HydrateFallback,
        children: [
          {
            path: "console",
            element: withSuspense(ButtonAssignment),
          },
          {
            path: "multiview",
            element: withSuspense(Multiview),
          },
        ],
      },
    ],
  },
  {
    path: ":equipmentGroupId/cameracontrol",
    loader: equipmentGroupLoader,
    element: withSuspense(CameraControl),
    shouldRevalidate: ({ currentParams, nextParams }) =>
      currentParams.equipmentGroupId !== nextParams.equipmentGroupId,
    HydrateFallback,
    children: [
      {
        index: true,
        element: withSuspense(CameraControlRedirect),
      },
      {
        path: ":cameraGroupId",
        loader: controlLoader,
        element: withSuspense(CameraGroupControl),
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.cameraGroupId !== nextParams.cameraGroupId,
        HydrateFallback,
        children: [
          {
            path: "sequence/:sequenceId",
            loader: presetSequenceLoader,
            element: withSuspense(PresetSequence),
            shouldRevalidate: ({ currentParams, nextParams }) =>
              currentParams.sequenceId !== nextParams.sequenceId,
            HydrateFallback,
          },
        ],
      },
    ],
  },
];

export default nodesRoutes;
